<template>
  <div class="nav_three_level_viewcolumn"
    :class="[this.$store.state.menubarRouters.full || hide||this.$route.query.hide?'full':'',this.$store.state.user.authencaticationStatus.packageArray.length>0?'has-notify':'']">
    <crumbs v-show="!hide"></crumbs>
    <notify v-if="this.$store.state.user.authencaticationStatus.packageArray.length>0"></notify>
    <transition name="fade" mode="out-in">
      <!--<keep-alive></keep-alive>-->
      <div class="pageWrap" :style="`${hide ? 'height: 100%' : ''}`" ref="pgWrap">
        <el-scrollbar class="content-scrollbar" style="height:100%;" ref='scrollbar'>
          <keep-alive :include="cachePageName">
            <router-view class="page-content" v-if="$route.meta.keepAlive" />
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive" class="page-content"></router-view>
        </el-scrollbar>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Crumbs, Notify } from '.'
import {testPoint} from '@/views/clue/api/newClueApi'
import { X_BLOCK ,X_PRODUCT,X_HIDE} from '@/utils/iframeUtils'
export default {
  name: 'three_level_view',
  components: {
    Crumbs,
    Notify
  },
  data () {
    return {
      hide: false,
      routeArr:[]
    }
  },
  computed: {
    ...mapState({ cachePageName: state => state.keepAliveStore.cachePageName })
  },
  watch: {
    // 重置滚动条
    '$route.path': {
      handler () {
        this.$nextTick(() => {
          this.toScrollTop(this.$route.meta.scrollTop || 0)
        })
        // this.scrollKey++
      }
    },
    '$route': {
      deep: true,
      immediate: true,
      handler: function (to, from) {
        this.addPoint(to,from)
      }
    }
  },
  mounted () {
    if (this.$route.query.hide) this.hide = true
    this.$bus.$on('set-scroll-top', this.setScrollTop)
    this.$bus.$on('to-scroll-top', this.toScrollTop)
  },
  methods: {
    preRouteUrl(obj){
      if(sessionStorage.getItem('preRouteStr')){
          if(JSON.parse(sessionStorage.getItem('preRouteStr')).length>1){
              let list = JSON.parse(sessionStorage.getItem('preRouteStr'))
              list.splice(0,1)
              sessionStorage.setItem('preRouteStr', JSON.stringify(list))
          }
          let arr = JSON.parse(sessionStorage.getItem('preRouteStr'))
          let arrT = []
          arrT.push(obj.path)
          let arrM = []
          arrM = arr.concat(arrT)
          sessionStorage.setItem('preRouteStr',JSON.stringify(arrM))
      }else{
           let arrT = []
           arrT.push(obj.path)
           sessionStorage.setItem('preRouteStr',JSON.stringify(arrT))
      }
    },
    // 埋点
    addPoint(to,from){
        let productName = ''
        if(window[X_PRODUCT]){
          productName = windowProductObj[window[X_PRODUCT]]
        }else{
            if(window[X_BLOCK]){
                productName = 'SCRM企微'
            }else{
              if(window[X_HIDE]){
                productName = 'SCRM专业'
              }else{
                  productName = (process.env.NODE_ENV == 'erp-prod' || process.env.NODE_ENV == 'erp')?'ERP-臻寻客':'T云-臻寻客'
              }
            }
        }
        if(window[X_HIDE]){
          this.preRouteUrl(to)
          this.routeArr = JSON.parse(sessionStorage.getItem('preRouteStr'))
          // if(this.routeArr.length == 1){
          //     this.routeArr.unshift('')
          // }
        }
        if((from && (to.path !=from.path)) || (this.routeArr.length == 2 && (this.routeArr[0] != this.routeArr[1]))){
             let paramsM ={
              eventType:'access_record_submodular',//事件类型
              productName:productName,//产品线名称
              currentPageId:window[X_HIDE]?this.routeArr[1]:to.path,
              previousPageId:window[X_HIDE]?this.routeArr[0]:(from?from.path:'')
            }
            testPoint(paramsM).then(res =>{

            }).catch(err =>{

            })
        }
    },
    toScrollTop (event) {
      if (!this.$refs.scrollbar) return
      const wrap = this.$refs.scrollbar.wrap
      wrap.scrollTop = event || 0
      this.$refs.scrollbar.handleScroll()
      this.$refs.scrollbar.update()
    },
    setScrollTop (event) {
      if (event == undefined) {
        const wrap = this.$refs.scrollbar.wrap
        event = wrap.scrollTop
      } else {
        event = event || 0
      }
      this.$route.meta.scrollTop = event
    }
  },
  destroyed () {
    this.$bus.$off('set-scroll-top', this.setScrollTop)
    this.$bus.$off('to-scroll-top', this.toScrollTop)
  }
}
</script>

<style scoped lang="scss">
.nav_three_level_viewcolumn {
  width: calc(100% - 192px);
  height: calc(100%);
  overflow: auto;
}

.nav_three_level_viewcolumn.full {
  width: 100%;
}
.pageWrap {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 39px);
  padding-left: calc(100vw - 100% - 244px);
  padding: 16px 0px 0px 0px;
  .page-content {
    margin: 0 auto;
    padding-left: 24px;
    padding-right: 24px;
    // width: 1100px;
  }

  // /deep/ .el-scrollbar__thumb:last-child {
  //   width: 0 !important;
  
  // }
}

.nav_three_level_viewcolumn.has-notify {
  /deep/ .x-notify {
    background-color: #f0f2f5;
    padding-bottom: 15px;
    > p {
      line-height: 50px;
      background-color: #fff;
      padding: 0 15px;
      font-size: 12px;
      height: 50px;
    }
  }
  .page-content {
    height: calc(100% - 100px);
  }
}
/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
